<template>
  <div class="KontaktCard boxShadow">
    <b-card class="KontaktCard" border-variant="warning" no-body>
      <b-card-header header-bg-variant="warning" class="text-white text-left p-1">
        <h4 class="m-1">{{ kontakt.vorname }} {{ kontakt.name }} <font-awesome-icon icon="cog" class=" float-right grow" @click="$bvModal.show(`kontaktBearbeiten-${kontakt.id}`)"/></h4>
      </b-card-header>
      <b-card-img
        v-if="kontakt.image"
        :src="`data:${kontakt.contentType};base64,${kontakt.image}`"
        alt="Bild"
        class="kontakt-img"
      ></b-card-img>
      <b-card-img
        v-else
        :src="require('@/assets/profile.png')"
        alt="Bild"
        class="kontakt-img"
      ></b-card-img>
      <b-card-footer footer-bg-variant="warning" v-b-modal.kontakt-message-${kontakt.id} @click="$bvModal.show(`kontakt-message-${kontakt.id}`)">
        <font-awesome-icon icon="envelope" class="text-white icon-size grow"/>
      </b-card-footer>
    </b-card>

    <!-- Kontakt bearbeiten Modal -->
    <b-modal :id="`kontaktBearbeiten-${kontakt.id}`" title="Kontakt bearbeiten" header-bg-variant="warning" header-text-variant="white" size="lg" hide-footer>
      <KontaktBearbeiten :kontakt="kontakt" @createUpdateToast="makeToast"/>
    </b-modal>

    <!-- Nachricht senden Modal -->
    <b-modal :id="`kontakt-message-${kontakt.id}`" :title="`${kontakt.vorname} ${kontakt.name} eine Nachricht senden`" header-bg-variant="warning" header-text-variant="white" size="lg" hide-footer>
      <b-form-group>
        <b-form-radio v-model="selected" name="nachricht" value="Bitte anrufen"><h3 class="p-3"><strong>Bitte anrufen</strong></h3></b-form-radio>
        <hr>
        <b-form-radio v-model="selected" name="nachricht" value="Ich muss einkaufen gehen"><h3 class="p-3"><strong>Ich muss einkaufen gehen</strong></h3></b-form-radio>
        <hr>
        <b-form-radio v-model="selected" name="nachricht" value="Ich brauche Hilfe"><h3 class="p-3"><strong>Ich brauche Hilfe</strong></h3></b-form-radio>
        <hr>
      </b-form-group>

      <b-button variant="success" class="float-right" size="lg" @click="sendMessage()" v-bind:disabled="selected === ''">Nachricht senden</b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import KontaktBearbeiten from './KontaktBearbeiten'

export default {
  name: 'KontaktCard',
  components: {
    KontaktBearbeiten
  },
  props: ['kontakt'],
  computed: mapGetters(['benutzer', 'benutzerStatus']),
  methods: {
    ...mapActions(['kontaktEmailSenden']),
    sendMessage () {
      const messageData = {}

      messageData.kontaktId = this.kontakt.id
      messageData.message = {
        subject: `${this.benutzer.vorname} ${this.benutzer.name}: ${this.selected}`,
        content: `Telefon: ${this.benutzer.tel} \nMobil: ${this.benutzer.mobil} \n\n${this.benutzer.strasse}\n${this.benutzer.plz} ${this.benutzer.ort}\n${this.benutzer.land}`
      }

      this.kontaktEmailSenden(messageData)
        .then(() => {
          const toastData = {
            title: "",
            msg: "Die Nachricht wurde gesendet.",
            variant: "success"
            }

          if (this.benutzerStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.benutzerStatus.errMsg;
            toastData.variant = "danger";
          }

          this.makeToast(toastData)

          if (!this.benutzerStatus.errMsg) {
            this.$bvModal.hide(`kontakt-message-${this.kontakt.id}`);
          }
        })
    },
    
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  data () {
    return {
      selected: 'Bitte anrufen'
    }
  }
};
</script>

<style scoped>
.KontaktCard {
  height: 100%;
}

.boxShadow {
  box-shadow: 0px 0px 4px #1a1a1a;
}

.kontakt-img {
  width: 100%;
  max-height: 12rem;
  overflow: hidden;
  object-fit: cover;
}

.grow {
  transition: all .2s ease-in-out;
}

.grow:hover {
  cursor: pointer;
  transform: scale(1.1);
}

.icon-size {
  font-size: 2em
}
</style>